module.exports = __webpack_public_path__ + "img/dongle_direction.5cd65189.svg";